module.exports = __webpack_public_path__ + "img/p1.05e9eefb.png";